/** Day-of-week values match .NET `System.DayOfWeek` (0 = Sunday … 6 = Saturday). */
export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

/** Only one notification type exists today. */
export enum NotificationType {
  BillingReminder = 1,
}

/* ── Wire types (integers on the wire; debtorId/companyId travel as headers) ── */

export interface ScheduleResponse {
  debtorId: number;
  notificationType: number;
  isEnabled: boolean;
  dayOfWeek: number;
  hourLocal: number;
  timeZone: string;
  isCustomized: boolean;
}

export interface SchedulePreferences {
  isEnabled: boolean;
  dayOfWeek: number;
  hourLocal: number;
  timeZone: string;
}

/** POST /schedule body has the same shape as the editable working copy. */
export type SchedulePayload = SchedulePreferences;

export interface DestinationResponse {
  emailSettingId: number;
  emailAddress: string;
  isActive: boolean;
  createdBy: string;
  modifiedBy: string;
  dateCreated: string;
  dateModified: string;
}

/**
 * A single change in a POST /destinations request. Omit `emailSettingId` to add;
 * include it to update/rename; include it with `isActive:false` to soft-delete.
 * Never send audit fields.
 */
export interface DestinationChange {
  emailSettingId?: number;
  emailAddress: string;
  isActive: boolean;
}

/* ── Form/view model ── */

export interface DestinationRow {
  /** Stable client key for React lists (never sent to the API). */
  key: string;
  /** Undefined for a row that has not been saved yet. */
  emailSettingId?: number;
  emailAddress: string;
  isActive: boolean;
}

export interface TimeZoneOption {
  label: string;
  ianaId: string;
}
